export type OptimizeConfig = {
    ABConfig: ScreenOrder;
    componentText: MessageProperties;
    componentVisibility: FieldVisibility;
    showPartnersWithLines: boolean;
    showPartnerNavigationOnMobile: boolean;
    showLoanConfigurationWithBorderedInput: boolean;
};

type ScreenOrder = {
    ScreenOrder: ScreenOrderItem[];
}

type ScreenOrderItem = {
    id: string;
    fields: string[];
};

export type MessageProperties = {
    loanConfigurationTitle: string;
}

export type FieldVisibility = {
    loanReasonDescription: boolean;
    aboutCompanyAdvice: boolean;
}

export const defaultOptimizeConfig: OptimizeConfig = {
    ABConfig: null,
    showPartnerNavigationOnMobile: true,
    showPartnersWithLines: false,
    showLoanConfigurationWithBorderedInput: false,
    componentText: {
        loanConfigurationTitle: 'temos um valor pré-aprovado!'
    },
    componentVisibility: {
        loanReasonDescription: true,
        aboutCompanyAdvice: false
    }
};
